import React from 'react';
import { I18nSupport } from '@/utils/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ComponentWithProps } from '@visalex/core';

import cx from 'clsx';
import { useTranslation } from 'next-i18next';

import styles from './SuccessRate.module.scss';

const SuccessRate: ComponentWithProps<I18nSupport> = ({ className, i18nPrefix }) => {
  const { t } = useTranslation();

  return (
    <section className={cx(className, styles['success-rate'])}>
      <div className={styles['success-rate__number']}>
        <div className={cx(styles['success-rate__separator'], styles['success-rate__separator--first'])}>
          <FontAwesomeIcon icon="star" />
        </div>
        <h4>97%</h4>
        <h6>{t(`${i18nPrefix}.success-rate`)}</h6>
        <div className={cx(styles['success-rate__separator'], styles['success-rate__separator--last'])}>
          <FontAwesomeIcon icon="star" />
        </div>
      </div>
    </section>
  );
};

export default SuccessRate;
